import { Component, OnInit, Input, ContentChild, TemplateRef } from '@angular/core';
import { ProfileService } from 'src/app/api/profile.service';
import { UserAccess, UserAccessSection, UserAccessSectionState } from 'src/app/models/user-access';

@Component({
  selector: 'user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.scss']
})
export class UserAccessComponent implements OnInit {
  @Input() section: UserAccessSection;
  @Input() sections: UserAccessSection[];

  @ContentChild('prefix') prefix: TemplateRef<void>;
  @ContentChild('suffix') suffix: TemplateRef<void>;

  State = UserAccessSectionState;

  access: UserAccess;

  constructor(private profileService: ProfileService) {
  }

  ngOnInit() {
    this.profileService.getAccessList().subscribe(response => {
      if (this.sections) {
        this.access = response[this.sections[0]];

        if (this.access.state === UserAccessSectionState.ALLOWED) {
          this.access = response[this.sections[1]];
        }
      } else {
        this.access = response[this.section];
      }
    });
  }

}
